import PropTypes from 'prop-types';
import React, { Component } from 'react';
import Actions from 'webapp/actions/actions';
import Constants from 'webapp/helpers/constants';
import FunctionalityAccessHelper from 'webapp/helpers/functionality_access_helper';

import Anchor from 'webapp/components/shared/anchor';
import LocationHelper from '../../../helpers/location_helper';

class AdminDashboardMenu extends Component {
  static propTypes = {
    user: PropTypes.object.isRequired,
    userSettingValues: PropTypes.array.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      tiersCounts: {
        [Constants.ADMIN_TIER.ONE]: null,
        [Constants.ADMIN_TIER.TWO]: null,
        [Constants.ADMIN_TIER.ESCALATED]: null,
      },
    };
  }

  goToFirstTierDocumentReview = () => {
    Actions.setRoute('/admin/financing-request-documents/tier-1');
  };

  render() {
    const {
      user: { atype },
      userSettingValues,
    } = this.props;

    return (
      <div className="admin-dashboard-menu" style={{ paddingTop: '25px' }}>
        <h2>Underwriting</h2>
        <ul>
          <li>
            <h3>
              <a
                href={`${LocationHelper.getUrlForSubdomain('uw')}`}
                rel={'noreferrer'}
                target={'_blank'}
                {...{ className: 'stips-dashboard' }}
              >
                Go to Underwriting Dashboard
              </a>
            </h3>
          </li>
        </ul>
        <div className="sections-separator" />
        <h2>Real Time Document Review</h2>
        <ul>
          {FunctionalityAccessHelper.hasAccessToTier1StepDocs(atype, userSettingValues) && (
            <li>
              <h3>
                <Anchor {...{ className: 'tier-1-dashboard', onClick: this.goToFirstTierDocumentReview }}>
                  Review Wet Signed Documents
                </Anchor>
              </h3>
            </li>
          )}
        </ul>
      </div>
    );
  }
}

export default AdminDashboardMenu;
